/**
 * Where choosing another organization in the pane's switcher goes, or null
 * to stay on the page and only change where the pane's Organization links
 * point.
 *
 * On an organization's own page it is the same page for the other one, so
 * Members of one office goes to Members of the other. On any other page it is
 * nowhere: the switcher used to go to the other organization's settings from
 * wherever it was used, and from the sending page that threw away a document
 * half made.
 */
export function orgSwitchTarget(pathname: string, orgId: string): string | null {
  const m = pathname.match(/^\/orgs\/[^/]+(?:\/([^/]+))?/)
  if (!m) return null
  return `/orgs/${orgId}/${m[1] ?? 'settings'}`
}
